import { injectReducer } from 'store/reducers'
import { injectSagas } from 'store/sagas'
import DiscoveryRoute from './routes/Discovery'

export const reducerKey = 'auth'


export default (store) => ({

  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Auth = require('./containers/AuthContainer').default
      //const reducer = require('./modules/reducer').default
      const sagas = require('./modules/sagas').sagas

      /*  Add the reducer to the store on key 'auth'  */
      //injectReducer(store, { key: reducerKey, reducer }) // moved reducer to be a synchronously loaded reducer in /store/reducers.js
      injectSagas(store, { key: 'auth', sagas })

      /*  Return getComponent   */
      cb(null, Auth)

    /* Webpack named bundle   */
    }, 'Auth')
  },

  indexRoute: { onEnter: (nextState, replace) => replace('/splash') },

  childRoutes: [
    DiscoveryRoute(store)
  ]
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/index.js
 **/